export const sectionMappings = {
  // Main pages
  home: {
    name: 'Home',
    path: '/'
  },
  about: {
    name: 'About Us',
    path: '/about'
  },
  contact: {
    name: 'Contact',
    path: '/contact'
  },
  team: {
    name: 'Our Team',
    path: '/team'
  },
  support: {
    name: 'Support Us',
    path: '/support'
  },
  'take-action': {
    name: 'Take Action',
    path: '/take-action'
  },
  experts: {
    name: 'Experts',
    path: '/experts'
  },
  'advisory-board': {
    name: 'Advisory Board',
    path: '/advisory-board'
  },
  faqs: {
    name: 'FAQs',
    path: '/faqs'
  },
  glossary: {
    name: 'Glossary',
    path: '/glossary'
  },
  watchlist: {
    name: 'Watchlist',
    path: '/watchlist'
  },
  
  // Article categories (most important for navigation)
  'the-climate-crisis': {
    name: 'The Climate Crisis',
    path: '/article-category/the-climate-crisis'
  },
  environment: {
    name: 'Environment',
    path: '/article-category/environment'
  },
  'ethics-of-food': {
    name: 'Ethics of Food',
    path: '/article-category/ethics-of-food'
  },
  'food-systems': {
    name: 'Food Systems',
    path: '/article-category/food-systems'
  },
  health: {
    name: 'Health',
    path: '/article-category/health'
  },
  'media-literacy': {
    name: 'Media Literacy',
    path: '/article-category/media-literacy'
  },
  nutrition: {
    name: 'Nutrition',
    path: '/article-category/nutrition'
  },
  'politics-of-food': {
    name: 'Politics of Food',
    path: '/article-category/politics-of-food'
  },
  'popular-media': {
    name: 'Popular Media',
    path: '/article-category/popular-media'
  },
  
  // Article pages
  'latest-articles': {
    name: 'Latest Articles',
    path: '/latest-articles'
  },
  'all-articles': {
    name: 'All Articles',
    path: '/all-articles'
  },
  'opinion-articles': {
    name: 'Opinion Articles',
    path: '/opinion-articles'
  },
  'top-fact-check-articles': {
    name: 'Top Fact-Check Articles',
    path: '/top-fact-check-articles'
  },
  
  // Informational pages
  'our-funding-disclosures': {
    name: 'Funding Disclosures',
    path: '/our-funding-disclosures'
  },
  'report-misinformation': {
    name: 'Report Misinformation',
    path: '/report-misinformation'
  },
  'send-feedback': {
    name: 'Send Feedback',
    path: '/send-feedback'
  },
  'fact-checking-policies': {
    name: 'Fact-Checking Policies',
    path: '/fact-checking-policies'
  },
  'media-mentions': {
    name: 'Media Mentions',
    path: '/media-mentions'
  },
  'independence-transparency': {
    name: 'Independence & Transparency',
    path: '/independence-transparency'
  },
  'organisational-structure': {
    name: 'Organisational Structure',
    path: '/organisational-structure'
  }
};
